const GenerarAlt = (data) =>{
  let texto = data?.altText ? data?.altText : data?.title;
  return texto;
}

export default GenerarAlt;